import { Button, Stack, Text, Title } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { Link } from 'react-router';
import { CenteredScreen } from '@/components/centered-screen';
import { LogoMark } from '@/components/logo';

export function NotFoundPage() {
  return (
    <CenteredScreen>
      <Stack align="center" gap="sm">
        <LogoMark size={48} />
        <Title order={2}>Page not found</Title>
        <Text c="dimmed" ta="center">
          That route does not exist.
        </Text>
        <Button
          component={Link}
          to="/"
          mt="sm"
          variant="light"
          leftSection={<IconArrowLeft size={16} />}
        >
          Back to dashboard
        </Button>
      </Stack>
    </CenteredScreen>
  );
}
